import { trigger } from '@angular/animations';
import { isPlatformServer, NgIf } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { fadeUpIfSubtle } from 'src/app/animations/fade-up-subtle.if.animation';
import { getScrollbarWidth } from 'src/app/lib/get-scrollbar-width';
import { isMac } from 'src/app/lib/is-mac';
import { TooltipService } from 'src/app/services/tooltip.service';
import { TooltipOptions } from 'src/app/types/tooltip';

@Component({
  selector: 'app-tooltip-global',
  templateUrl: './tooltip-global.component.html',
  styleUrls: ['./tooltip-global.component.scss'],
  animations: [trigger('tooltip', fadeUpIfSubtle)],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgIf],
})
export class TooltipGlobalComponent {
  text: string;
  keyboardShortcut: string;
  keyboardShortcutMeta: boolean;
  htmlContent: SafeHtml;
  title: string;
  imageUrl: string;
  style: 'dark' | 'light';
  position: TooltipOptions['position'];
  size: 'normal' | 'big';
  el: HTMLElement;
  top: number;
  left: number;
  right: number;
  bottom: boolean;
  metaKey: string;

  @HostListener('window:scroll', ['$event']) docScroll(event: Event) {
    if (!this.text) return;
    this.tooltipService.hide();
  }

  constructor(private tooltipService: TooltipService, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformServer(this.platformId)) return;
    this.metaKey = isMac() ? 'CMD' : 'Crl';

    this.tooltipService.onTooltipShow.subscribe(event => {
      if (event) {
        this.text = event.text;
        this.el = event.el;
        this.style = event.style;
        this.position = event.position;
        this.title = event.title;
        this.imageUrl = event.imageUrl;
        this.htmlContent = event.htmlContent;
        this.size = event.size;
        this.keyboardShortcut = event.keyboardShortcut;
        this.keyboardShortcutMeta = event.keyboardShortcutMeta;
      } else {
        this.text = undefined;
        this.el = undefined;
        this.htmlContent = undefined;
        this.keyboardShortcut = undefined;
      }
      this.calcPos();
    });
  }

  calcPos() {
    if (!this.el) {
      this.top = undefined;
      this.left = undefined;
      this.right = undefined;
      return;
    }

    const rect = this.el.getBoundingClientRect();

    if (this.position === 'top' || this.position === 'top-left' || this.position === 'top-right') {
      this.top = rect.top;
      this.left = rect.left + rect.width / 2;
      this.right = undefined;
      if (this.size === 'big') {
        if (this.left < 150) this.left = 150;
        if (this.left > window.innerWidth - 150) this.left = window.innerWidth - 150;
      } else {
        if (this.left < 100 && this.text.length > 20) this.left = 100;
        if (this.left > window.innerWidth - 100 && this.text.length > 20) this.left = window.innerWidth - 100;
      }
      if (this.top < 40) {
        this.top = rect.top + rect.height;
        this.bottom = true;
      } else {
        this.bottom = false;
      }
    }

    if (this.position === 'top-left') {
      this.left = rect.left;
    }

    if (this.position === 'top-right') {
      this.right = window.innerWidth - rect.right;
      this.left = undefined;
    }

    if (this.position === 'right') {
      this.bottom = false;
      this.top = rect.top + rect.height / 2;
      this.left = rect.left + rect.width;
      this.right = undefined;
    }

    if (this.position === 'left') {
      this.bottom = false;
      this.top = rect.top + rect.height / 2;
      this.left = undefined;
      this.right = window.innerWidth - rect.right + rect.width - getScrollbarWidth();
    }
  }
}
